import { Routes, Route } from "react-router-dom";
// import "react-notifications/lib/notifications.css";
// import { NotificationContainer } from "react-notifications";
import Header from "./components/App/Header";
import RequireAuth from "./components/AuthGuard/RequireAuth";
import { useState, useEffect } from "react";
import AppContext from "./components/Context/Context";
import { GlobalStateProvider } from "./components/Context/GlobalStateContext";
import JLRSSOResponse from "./components/Pages/JLRSSOResponse ";
import SSOLogin from "./components/Pages/SSOLogin";
import PFIJLRLGN from "./components/Pages/pfijlrlgn";
function App() {
  return (
    <main>
      {/* <NotificationContainer /> */}
      <GlobalStateProvider>
      <div className="App--main">
        <Header />
        <div className="Body--Main">
          {/* <Routes>
            <Route path="" element={<SSOLogin />} />
            <Route path="login" element={<SSOLogin />} />
            <Route path="jlrssoresp" element={<JLRSSOResponse />} />
            <Route path="pfijlrlgn" element={<PFIJLRLGN />} />
            <Route path="*" element={<SSOLogin />} />
          </Routes> */}


          <Routes>
            <Route path="" element={<PFIJLRLGN />} />
            <Route path="login" element={<PFIJLRLGN />} />
            <Route path="jlrssoresp" element={<JLRSSOResponse />} />
            <Route path="pfijlrlgn" element={<PFIJLRLGN />} />
            <Route path="*" element={<PFIJLRLGN />} />
          </Routes>



        </div>
      </div>
      </GlobalStateProvider>
    </main>
  );
}

export default App;
